<template>
  <div class="print">
    <div class="contents">
      <div class="title">
        <span>{{ $t('안 전 보 건 관 리 책 임 자') }}<span class="mx-6"></span>{{ $t('지 정 서') }}</span>
      </div>

      <div class="userInfo">
        <p>{{ $t('소 속') }} : {{ form.inputC_2 }}</p>
        <p>{{ $t('직 책') }} : {{ form.inputC_3 }}</p>
        <p>{{ $t('성 명') }} : {{ form.inputC_1 }}</p>
      </div>

      <div class="message">
        <p class="mb-8">{{ $t('위 사람을 산업안전보건법 제15조 및 동법 시행령 제14조에 의거 아래와 같은 안전관리에 대한 업무를 수행할 수 있도록 당사의 안전보건관리책임자로 지정합니다.') }}</p>
        <p class="mt-8">{{ $t('■ 안전보건관리책임자(산업안전보건법 제15조)') }}</p>
        <p>{{ $t('① 사업주는 사업장을 실질적으로 총괄하여 관리하는 사람에게 해당 사업장의 다음 각 호의 업무를 총괄하여 관리하도록 하여야 한다.') }}</p>
        <p>{{ $t('1. 사업장의 산업재해 예방계획의 수립에 관한 사항') }}</p>
        <p>{{ $t('2. 제25조 및 제26조에 따른 안전보건관리규정의 작성 및 변경에 관한 사항') }}</p>
        <p>{{ $t('3. 제29조에 따른 안전보건교육에 관한 사항') }}</p>
        <p>{{ $t('4. 작업환경측정 등 작업환경의 점검 및 개선에 관한 사항') }}</p>
        <p>{{ $t('5. 제129조부터 제132조까지에 따른 근로자의 건강진단 등 건강관리에 관한 사항') }}</p>
        <p>{{ $t('6. 산업재해의 원인 조사 및 재발 방지대책 수립에 관한 사항') }}</p>
        <p>{{ $t('7. 산업재해에 관한 통계의 기록 및 유지에 관한 사항') }}</p>
        <p>{{ $t('8. 안전장치 및 보호구 구입 시 적격품 여부 확인에 관한 사항') }}</p>
        <p>{{ $t('9. 그 밖에 근로자의 유해ㆍ위험 방지조치에 관한 사항으로서 고용노동부령으로 정하는 사항') }}</p>
        <p>{{ $t('② 제1항 각 호의 업무를 총괄하여 관리하는 사람(이하 “안전보건관리책임자”라 한다)은 제17조에 따른 안전관리자와 제18조에 따른 보건관리자를 지휘ㆍ감독한다.') }}</p>
        <p>{{ $t('③ 안전보건관리책임자를 두어야 하는 사업의 종류와 사업장의 상시근로자 수, 그 밖에 필요한 사항은 대통령령으로 정한다.') }}</p>
      </div>

      <div class="sign">
        <div class="yyyyMMdd p-8">
          <span class="year pr-6">{{ form.inputC_5 | moment("YYYY") }} {{ $t('년') }}</span>
          <span class="month pr-6">{{ form.inputC_5 | moment("MM") }} {{ $t('월') }}</span>
          <span class="day">{{ form.inputC_5 | moment("DD") }} {{ $t('일') }}</span>
        </div>

        <div class="body">{{ form.inputC_0 }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Print",
  props: {
    border: Object,
    form: Object,
  },
};
</script>

<style lang="scss" scoped>
.print {
  padding: 2rem 1rem;

  & > .contents {
    display: grid !important;
    width: 100%;
    height: auto;

    border: 1px solid #cdcdcd;

    padding: 1.5rem;
  }
}
.title {
  padding-top: 2rem;
  padding-bottom: 2rem;
  margin-bottom: 2rem;

  display: grid;
  align-items: center;
  justify-content: center;

  font-size: 3rem;
  font-weight: bold;
}

.userInfo {
  display: grid;
  justify-content: flex-end;
  margin-bottom: 1.25rem;

  & > p {
    width: 400px;

    font-size: 1.5rem;
    font-weight: 500;

    padding: 1rem 0;
    margin-bottom: 1rem;
  }
}

.message {
  p {
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 3.125rem;

    &.sub {
      padding-left: 1.5rem;
      font-size: 1.375rem;
      font-weight: 400 !important;
      line-height: 2.875rem;
    }
  }
}

.sign {
  padding-top: 40px;

  display: grid;
  justify-content: center;

  .yyyyMMdd {
    display: flex;
    justify-content: center;
    font-size: 1.6875rem;

    margin-bottom: 4rem;
  }

  .body {
    font-size: 48px;
    font-weight: 700;
    color: #3c3c3c;
    text-align: center;
    line-height: 2.75rem;
    margin-bottom: 40px;
  }
}
</style>
